import React from "react";
import SEO from "../shared/SEO";
import LandingPageNavbar from "../landing-page/LandingPageNavbar";
import Navbar from "./Navbar";
import Footer from "./Footer";
const RefundAndCancellation: React.FC = () => {
  return (
 <div className="min-h-screen bg-white text-gray-900">
      <SEO
        title="Refund and Cancellation Policy | Orcas Valley"
        description="Review Orcas Valley's refund and cancellation policy for our services and subscriptions."
        url="https://orcasvalley.web.app/refund-and-cancellation"
        keywords="refund policy, cancellation policy, money back guarantee, service cancellation"
      />
     <Navbar />

      {/* Hero Section */}
      <header className="relative text-white h-[85vh] flex items-center justify-start px-5 md:px-10">
  {/* Background Image */}
  <div className="absolute inset-0 px-5 md:px-10">
    <div
      className="w-full h-full bg-cover bg-center rounded-xl"
      style={{ backgroundImage: "url('/t&c.png')" }}
    ></div>
  </div>

  <div className="absolute inset-0 rounded-xl"></div>

  {/* Content */}
  <div className="relative z-10 flex items-center px-5 sm:px-10 lg:px-28 w-full mt-20 sm:mt-32 md:mt-44">
    <div>
      <h1 className="text-4xl sm:text-5xl md:text-6xl font-semibold leading-tight">
       Refund and  <br /> Cancellation
      </h1>
    </div>
  </div>

  {/* Side Text (Vertical) */}
  <div className="absolute top-6 left-3 xs:left-2 sm:top-10 sm:left-6 md:left-10 z-20 px-5 flex flex-col items-center text-gray-300 text-lg tracking-widest  sm:flex">
    <div className="border-l-2 border-gray-300 h-6 sm:h-10 mb-1 sm:mb-2"></div>
    <p className="flex flex-col text-center text-xs">
    <span>T</span>
      <span>H</span>
      <span>E</span>
      <br />
      <span>O</span>
      <span>R</span>
      <span>C</span>
      <span>A</span>
      <span>S</span>
      <br />
      <span>W</span>
      <span>A</span>
      <span>Y</span>
    </p>
  </div>
</header>


      {/* Content Section */}
      <div className="max-w-3xl mx-auto bg-white p-6  text-gray-900 mt-6">
        {/* <h1 className="text-3xl font-bold mb-6">Refund and Cancellation Policy</h1> */}

        <p className="mb-4">
          All purchases made on Orcas Valley are final.
        </p>

        <p className="mb-4">
          Once you access the platform, download The Orca Blueprint, or use any of the included tools or resources, refunds and cancellations are not available. Accessing any part of the package is considered full service delivery.
        </p>

        <p className="mb-4">
          If you complete the payment but cannot access the platform and have not downloaded or received any materials, our team will review your case.
        </p>

        <p className="mb-4">
          We will attempt to resolve the issue promptly. If the problem cannot be fixed, you may be eligible for a refund.
        </p>

        <p className="mb-4">
          Approved refunds will be processed within 15 working days.
        </p>

        <p className="mb-4">
          For support or refund inquiries, contact our team at <a href="mailto:support@orcasvalley.com" className="text-blue-600 underline">support@orcasvalley.com</a>.
        </p>
      </div>

      <Footer />
    </div>
  );
};

export default RefundAndCancellation;